/** @ignore *//** */
const config = {
  version: '2.16.5',
  type: 'js'
};

export default config;